import { Helmet } from "react-helmet-async";
import { SITE_URL } from "@/lib/site";

export const Seo = ({ title, description, path = "/", noindex = false }) => (
  <Helmet>
    <title>{title ? `${title} | SLN Agro Exports` : "SLN Agro Exports | Indian Banana, Onion & Pomegranate Exporter"}</title>
    {description && <meta name="description" content={description} />}
    {description && <meta property="og:description" content={description} />}
    <meta property="og:title" content={title || "SLN Agro Exports"} />
    <meta property="og:type" content="website" />
    <link rel="canonical" href={`${SITE_URL}${path}`} />
    {noindex && <meta name="robots" content="noindex, nofollow" />}
  </Helmet>
);
